const checkoutCatalog = new Set();

// components displayed
checkoutCatalog
    .add('psd2-iframe')
    .add('psd2-error-popup')
    .add('repricing-popup-manager')
    .add('expensive-repricing-manager')
    .add('cheap-repricing-manager')
    .add('ancillaries_payment_continue_button_load')
    .add('payment_continue_button_load');

// component clicks
checkoutCatalog
    .add('confirm-repricing-cheap')
    .add('reject-repricing-cheap')
    .add('cancel-repricing-popup-button')
    .add('close-repricing-popup')
    .add('confirm-repricing')
    .add('payment-continue-button');

export default checkoutCatalog;
